<template>
    <el-drawer title="演出预览" 
        :visible.sync="drawerShow" 
        :wrapperClosable="false" 
        :destroy-on-close="true" 
        append-to-body
        size="auto" 
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
			<div>
				<div>预览链接：</div>
				<el-link type="primary" :href="`${sswap}/pages/activity/detail/detail?activityId=${formData.activityId}`" target="_blank" class="MT5">
					{{wapUrl}} 
				</el-link>
				<div class="MT5">
					<el-button size="mini" type="success" plain @click="copy()">复制链接</el-button>
				</div>
			</div>
			<el-form :model="formData" ref="formData" class="MT10">
                <el-form-item prop="previewPwd" label="预览密码：">
                    <el-input type="password" size="medium" v-model="formData.previewPwd" placeholder="请输入预览密码"  maxlength="20" show-word-limit show-password></el-input>
					<small class="MT5"><span class="color-danger">在审核中的演出，支持设置密码后进行预览。<br>如果不设置密码，则不能预览</span></small>
                </el-form-item>
            </el-form>
			<div class="textCenter">
				<div class="textCenter MB20">演出二维码</div>
			    <div class="code">
					<vue-qr :logoSrc="logo" :text="wapUrl" :size="800" :logoMargin="8" logoBackgroundColor="#ffffff" :callback="getImage" :margin="0" ></vue-qr>
					<input class="copyTool" ref="copyTool" :value="wapUrl" />
				</div>	
				<div class="MT10 textCenter">
					<el-button type="primary" size="small" @click="copy">复制链接</el-button>
					<el-button type="primary" size="small" @click="downloadCode">下载二维码</el-button>
				</div>
			</div>			
			<div class="textCenter MT30" v-if="data && data.tourId">
				<div class="textCenter MB20">巡演二维码</div>
			    <div class="code">
					<vue-qr :logoSrc="logo" :text="xunyanUrl" :size="800" :logoMargin="8" logoBackgroundColor="#ffffff" :callback="getImage2" :margin="0" ></vue-qr>
					<input class="copyTool" ref="copyTool2" :value="xunyanUrl" />
				</div>
				<div class="MT10 textCenter">
					<el-button type="primary" size="small" @click="copyXunyan">复制链接</el-button>
					<el-button type="primary" size="small" @click="downloadCodeXunyan">下载二维码</el-button>
				</div>
			</div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="submitForm()">确 认</el-button>
        </div>
		<input class="copyTool" ref="copyTool" :value="wapUrl" />
    </el-drawer>
</template>
<script>
import VueQr from 'vue-qr'
import logo from '@/assets/img/logo.png';
const defaultFormData = {
    activityId:'',
    previewPwd:''
}
export default {
	components:{
	  VueQr
	},
    data(){		
        return{
            drawerShow: false,
            formData:{
                ...defaultFormData
            },
            btnLoading: false,
            dataLoading: false,
			copyTimer: null,
			copyTimer2: null,	
			sswap:`${process.env.VUE_APP_SSWAP_URL}`,
			wapUrl:'',
			codeImage:'',
			codeImage2:'',
			logo:logo,
			data:null,
			xunyanUrl:''
			
        }
    },
    methods:{
        show(data){
			this.data = data
            this.formData.activityId = data.id
            this.getDetails();
            this.drawerShow = true
			this.wapUrl=this.sswap+'/pages/activity/detail/detail?activityId='+data.id
			if( data && data.tourId ){
				this.xunyanUrl = this.sswap +'/pages/activity/list/list?type=1&tag='+data.tourId
			}
		
        },
        close(){
            this.formData = { ...defaultFormData };
            this.$refs.formData && this.$refs.formData.resetFields();
            this.drawerShow = false
        },
		getImage(url){
		    this.codeImage = url;
		},
		getImage2(url){
		    this.codeImage2 = url;
		},
		downloadCode(){
		    const _data = this.$utils.base64ToBlob(this.codeImage);
		    this.$utils.exportFile(_data,`${this.data.title}的演出二维码.png`);
		},
		downloadCodeXunyan(){
		    const _data = this.$utils.base64ToBlob(this.codeImage2);
		    this.$utils.exportFile(_data,`${this.data.title}的巡演二维码.png`);
		},
        getDetails(){
            this.dataLoading = true
            this.$request({
                url: '/activity/previewPwdInfo',
                params: {activityId: this.formData.activityId},
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.formData.previewPwd = result
                    } else {
                        this.$message.error(msg || "获取数据失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取数据失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
		//复制链接
		copy(){
			
		    clearTimeout(this.copyTimer);
		    this.copyTimer = setTimeout(() => {
		        const e = this.$refs.copyTool;
		        e.select();
		        document.execCommand("Copy"); // 执行浏览器复制命令
		        this.$message.success("链接已复制，可粘贴");
		    },300)
		},
		copyXunyan(){
			clearTimeout(this.copyTimer2);
			this.copyTimer2 = setTimeout(() => {
			    const e = this.$refs.copyTool2;
			    e.select();
			    document.execCommand("Copy"); // 执行浏览器复制命令
			    this.$message.success("链接已复制，可粘贴");
			},300)
		},
        submitForm(){
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    this.$request({
                        url: '/activity/previewPwdSave',
                        params: {...this.formData},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$message.success("设置成功！");
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }else{
                    return false;
                }
            })
        }
    }
    
}
</script>
<style lang="scss" scoped>

.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
.MT5{
	margin-top: 5px;
}
.textCenter{
	text-align: center;
}
.code{
	width: 200px;
	height: 200px;
	margin: 15px auto;
	img{
		width: 100%;
		max-width: 100%;
	}
}
</style>